//
//
export default [
  {
    path: "/dashboard",
    meta: { hideBottomNavigation: true },
    name: "dashboardHome",
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/dashboard.vue"),
    children: [
      {
        name: "mailDashboard",
        path: "mail",
        meta: {},
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/mail/Mail.vue"),
      },
      {
        name: "cooDashboard",
        path: "coo-dashboard",
        meta: { rights: ["stat_coo"] },
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/coo/cooDashboard.vue"),
      },
      {
        name: "toDoListDashboard",
        path: "todo",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/toDoList/toDoListDashboard.vue"),
        children: [
          {
            name: "toDoListMain",
            path: "/",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/toDoList/toDoListMain.vue"),
            meta: { displayedTitle: "ToDo's", rights: ["d_fetchAllDocs", "d_fetchDocs"] },
          },
        ],
      },
      {
        name: "documentsDashboard",
        path: "documents",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/documents/documentsDashboard.vue"),
        children: [
          {
            name: "documentsMain",
            path: "/",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/documents/documentsMain.vue"),
            meta: { displayedTitle: "Dokumente", rights: ["d_fetchAllDocs", "d_fetchDocs"] },
          },
          {
            name: "documentsMain",
            path: "statistics",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/documents/statistics.vue"),
            meta: { displayedTitle: "Statistik", rights: ["d_fetchAllDocs"] },
          },
        ],
      },
      {
        name: "shiftManagementDashboard",
        path: "shift-management",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/shiftManagement/shiftManagementDashboard.vue"),
        children: [
          {
            name: "shiftManagementPlan",
            path: "/",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/shiftManagement/shiftManagementMain.vue"),
            meta: { displayedTitle: "Arbeitseinsatz Planung | Erstellen und Bearbeiten", rights: ["tt_office"] },
          },
          {
            name: "shiftManagementSettings",
            path: "settings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/shiftManagement/shiftManagementSettings.vue"),
            meta: { displayedTitle: "Arbeitseinsatz Planung | Einstellungen", rights: ["tt_office"] },
          },
        ],
      },
      {
        name: "tacAccessDevices",
        path: "tac/access-devices",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/tac/tacAccessDevices.vue"),
        meta: { displayedTitle: "TAC Zugangsgeräte" },
      },
      {
        name: "healthcareView",
        path: "healthcare",
        component: () => import("@/views/dashboard/healthcareConfirmation/healthcareView.vue"),
        meta: { displayedTitle: "KK-Bestätigung Anfragen" },
      },
      {
        name: "timestopView",
        path: "timestop",
        component: () => import("@/views/dashboard/timestop/timestopView.vue"),
        meta: { displayedTitle: "Timestops Anfragen" },
      },
      {
        name: "timestopCalculator",
        path: "timestop-calc",
        component: () => import("@/views/dashboard/timestop/timestopCalculator.vue"),
        meta: { displayedTitle: "Timestop Rechner" },
      },
      {
        name: "homeDashboardCheckinStatistics",
        path: "checkin-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardCheckinStatistics.vue"),
        meta: { displayedTitle: "Check-IN Statistiken", statistics: true, multiStudio: true, rights: ["stat_viewstudio", "stat_admin"] },
      },
      {
        name: "homeDashboardUserStatistics",
        path: "user-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardUserStatistics.vue"),
        meta: {
          hideRange: true,
          displayedTitle: "Kunden Statistiken",
          statistics: true,
          multiStudio: true,
          rights: ["stat_viewstudio", "stat_admin"],
        },
      },
      {
        name: "homeDashboardStats",
        path: "stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardStats.vue"),
        meta: {
          hideRange: true,
          displayedTitle: "Statistiken",
          statistics: true,
          multiStudio: true,
          rights: ["stat_viewstudio", "stat_admin"],
        },
      },
      {
        name: "homeDashboardGroupFitnessStatistics",
        path: "gf-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardGroupFitnessStatistics.vue"),
        meta: { displayedTitle: "Group Fitness Statistiken", statistics: true, multiStudio: true, rights: ["stat_admin", "stat_gf", "stat_gf_stud"] },
      },
      {
        name: "homeDashboardTrainerStatistics",
        path: "trainer-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardTrainerStatistics.vue"),
        meta: {
          displayedTitle: "Trainer Statistiken",
          statistics: true,
          multiStudio: true,
          rights: ["stat_admin", "stat_viewstudio"],
        },
      },
      {
        name: "homeDashboardTrainerGoals",
        path: "trainer-goals",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardTrainerGoals.vue"),
        meta: {
          displayedTitle: "Trainer Monatsziele",
          statistics: true,
          monthsOnly: true,
          multiStudio: true,
          rights: ["stat_admin", "stat_viewstudio"],
          role: ["616616c4c659c875cad63525", "61661791c659c875cad63527"], // trainer
        },
      },
      {
        name: "homeDashboardGoalsStatistics",
        path: "goals-statistics",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardGoalsStatistics.vue"),
        meta: {
          displayedTitle: "Trainer Monatsziele",
          statistics: true,
          monthsOnly: true,
          multipleMonths: true,
          multiStudio: true,
          rights: ["stat_admin"],
        },
      },
      {
        name: "homeDashboardCenterMonthlyStatistics",
        path: "monthly-statistics",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardCenterMonthlyStatistics.vue"),
        meta: {
          displayedTitle: "Monatliche Statistiken Center",
          statistics: true,
          monthsOnly: true,
          multiStudio: false,
          rights: ["stat_admin", "stat_viewstudio"],
        },
      },
      {
        name: "homeDashboardTransactionStatistics",
        path: "transaction-statistics",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardTransactionStatistics.vue"),
        meta: { displayedTitle: "Transaktions Statistiken", statistics: true, multiStudio: true, rights: ["stat_admin", "stat_viewstudio"] },
      },
      {
        name: "homeDashboardEmployeeStatistics",
        path: "employee-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/employee/employeeStatistic.vue"),
        meta: { displayedTitle: "Mitarbeiter zahlen", rights: ["stat_employee", "stat_viewstudio"] },
      },
      {
        name: "homeDashboardMembercardStatistics",
        path: "membercard-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardMembercardStatistics.vue"),
        meta: { displayedTitle: "11 Tage Kampagne", rights: ["stat_admin"] },
      },
      {
        name: "homeDashboardAnamneseStatistics",
        path: "anamnese-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardAnamneseStatistics.vue"),
        meta: { displayedTitle: "Anamnese Statistiken", statistics: true, multiStudio: true, rights: ["stat_admin", "stat_viewstudio"] },
      },
      {
        name: "homeDashboardContractStatistics",
        path: "contract-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardContractStatistics.vue"),
        meta: { displayedTitle: "Vertrags Statistiken", statistics: true, multiStudio: true, rights: ["stat_admin", "stat_viewstudio"] },
      },
      {
        name: "homeDashboardContractPackagesStatistics",
        path: "packages-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardContractPackagesStatistics.vue"),
        meta: { displayedTitle: "Vertrags Statistiken", statistics: true, multiStudio: true, rights: ["stat_admin", "stat_viewstudio"] },
      },
      {
        name: "homeDashboardContractDevelopmentStatistics",
        path: "contract-development",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardContractDevelopment.vue"),
        meta: {
          displayedTitle: "Aboentwicklung (letzte 12 Monate)",
          statistics: true,
          hideRange: true,
          multiStudio: true,
          rights: ["stat_admin", "stat_viewstudio"],
        },
      },
      {
        name: "homeDashboardLeadStatistics",
        path: "lead-stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardLeadStatistics.vue"),
        meta: { displayedTitle: "Leads Statistiken", statistics: true, multiStudio: true, rights: ["stat_admin", "stat_viewstudio"] },
      },
      {
        name: "homeDashboardFigures",
        path: "figures",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/home/homeDashboardFigures.vue"),
        meta: { monthsOnly: true, displayedTitle: "Kennzahlen", statistics: true, multiStudio: false, rights: ["stat_admin", "stat_viewstudio"] },
      },
      {
        name: "liveCheckins",
        path: "live-checkins",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/attendance/liveCheckins.vue"),
        meta: { studioOnly: true, displayedTitle: "Live Checkins", rights: ["g_studioastat_admin", "stat_viewstudio", "live_checkins"] },
      },
      {
        name: "studioEditor",
        path: "studios",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studioEditor.vue"),
        meta: { displayedTitle: "Studio Admin", rights: ["g_studioadmin"] },
        children: [],
      },
      {
        name: "studioSignatures",
        path: "studios/signatures",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioSignatures.vue"),
        meta: { displayedTitle: "Studio Unterschriften", rights: ["g_studioadmin"] },
      },
      {
        name: "timeTracker",
        path: "timetracker",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/timetracker/EmployeeTimeTracker.vue"),
        meta: { displayedTitle: "Zeiterfassung", rights: ["g_studioadmin", "tt_employeeManage"] },
      },
      {
        name: "timeTrackerManagement",
        path: "timetracker/management",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/timetracker/ManagementTimeTracker.vue"),
        meta: {
          includeTeams: true,
          monthsOnly: true,
          statistics: true,
          displayedTitle: "Zeiterfassung Management",
          rights: ["g_studioadmin", "tt_management"],
        },
      },
      {
        name: "timeTrackerOffice",
        path: "timetracker/office",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/timetracker/OfficeTimeTracker.vue"),
        meta: {
          includeTeams: true,
          monthsOnly: true,
          displayedTitle: "Zeiterfassung Büro",
          statistics: true,
          rights: ["g_studioadmin", "tt_office"],
        },
      },
      {
        name: "nutritionSales",
        path: "contract/nutrition",
        component: () => import("@/views/dashboard/contract/nutritionSales.vue"),
        meta: { displayedTitle: "Ernährungsberatungen" },
      },
      {
        name: "contractSettingsOld",
        path: "contract/settingsold",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractSettings.vue"),
        meta: { displayedTitle: "Vertrags Einstellungen" },
      },
      {
        name: "contractSettings",
        path: "contract/settings",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/new/contractSettings.vue"),
        meta: { displayedTitle: "Vertrags Einstellungen" },
      },
      {
        name: "contractList",
        path: "contract",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractList.vue"),
        meta: { displayedTitle: "Verträge" },
      },
      {
        name: "contractManager",
        path: "contract/manager",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractManager.vue"),
        meta: { displayedTitle: "offene Verträge" },
      },
      {
        name: "contractStats",
        path: "contract/stats",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractStats.vue"),
        meta: { statistics: true, multiStudio: true, displayedTitle: "Statistik abgelehnte Verträge" },
      },
      {
        name: "contractManager",
        path: "contract/manager/map/:userId/:index",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/tac/components/contract/mapContract.vue"),
        meta: { displayedTitle: "Map TAC Contract" },
      },
      {
        name: "contractSettings",
        path: "contract/settings",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractSettings.vue"),
        meta: { displayedTitle: "Einstellungen" },
      },
      {
        name: "contractRejected",
        path: "contract/rejected",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractRejected.vue"),
        meta: { displayedTitle: "abgelehnte Verträge" },
      },
      {
        name: "contractTemporary",
        path: "contract/temporary",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractTemporary.vue"),
        meta: { displayedTitle: "zwischengespeicherte Verträge" },
      },
      {
        name: "contractFieldsManager",
        path: "contract/create",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractFieldsManager.vue"),
        meta: { displayedTitle: "Vertrag erstellen" },
      },
      {
        name: "contractFieldsManagerEdit",
        path: "contract/settings/:id",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractFieldsManager.vue"),
        meta: { displayedTitle: "Vertrag bearbeiten" },
      },
      {
        name: "contractCreator",
        path: "contract/create/:id",
        component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
        meta: { displayedTitle: "Vertrag Bearbeiten" },
      },
      {
        name: "tacContractsRoodyMapper",
        path: "contract/upgrade/mapping",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/components/tacContractsRoodyMapper.vue"),
        meta: { displayedTitle: "Vertrag Infos Mappen" },
      },
      {
        name: "contractUpgradesOpen",
        path: "contract/upgrade/created",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/components/upgradeContractView.vue"),
        meta: { displayedTitle: "Vertrag upgraden" },
      },
      {
        name: "contractUpgradesClosed",
        path: "contract/upgrade/rejected",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/components/upgradeContractView.vue"),
        meta: { displayedTitle: "Vertrag upgraden" },
      },
      {
        name: "contractUpgradesAccepted",
        path: "contract/upgrade/accepted",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/components/upgradeContractView.vue"),
        meta: { displayedTitle: "Vertrag upgraden" },
      },
      {
        name: "upgradeContractView",
        path: "contract/upgrade/deleted",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/components/upgradeContractView.vue"),
        meta: { displayedTitle: "Vertrag upgraden" },
      },
      {
        name: "monthlyReport",
        path: "monthly/report",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/monthlyReport/MonthlyReport.vue"),
        meta: { displayedTitle: "Monats Übersicht" },
      },
      {
        name: "contractViewer",
        path: "contract/view/:userId/:index",
        component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
        meta: { displayedTitle: "Dein Vertrag" },
      },
      {
        name: "contractEditor",
        path: "contract/edit/:userId/:index",
        component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
        meta: { displayedTitle: "Vertrag bearbeiten" },
      },
      {
        name: "contractLayoutManager",
        path: "contract/layout",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractLayoutManager.vue"),
      },
      {
        name: "payment",
        path: "payment",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/payment/Payment.vue"),
        meta: { displayedTitle: "Zahlungsabwicklung" },
      },
      {
        name: "paymentOverview",
        path: "payment/overview",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/payment/PaymentOverview.vue"),
        meta: { displayedTitle: "Zahlungsübersicht" },
      },
      {
        name: "paymentSettings",
        path: "payment/settings",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/payment/PaymentSettings.vue"),
        meta: { displayedTitle: "Einstellungen" },
      },
      {
        name: "workouts",
        path: "workouts",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/workouts/workoutsDashboard.vue"),
        children: [
          {
            name: "workoutsDashboardFeedback",
            path: "feedback",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/workouts/workoutsFeedback.vue"),
            meta: { displayedTitle: "Trainingsplan Bewertungen", needsLoader: true, rights: ["tp_feedback"] },
          },
          {
            name: "workoutsDashboardSearchAndCreate",
            path: "search-and-create",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/workouts/workoutsDashboardSearchAndCreate.vue"),
            meta: { displayedTitle: "Trainingsplan suchen und erstellen", rights: ["tp_create", "tp_viewAll"] },
          },
        ],
      },
      {
        name: "studio",
        path: "studio",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioDashboard.vue"),
        children: [
          {
            path: "/reservation-admin",
            name: "ReservationToolAdmin",
            meta: { displayedTitle: "Reserverierungstypen bearbeiten", rights: ["reservations_createType"] },
            component: () => import("@/views/reservationTool/views/admin/ManageReservationTypes.vue"),
          },
          {
            path: "/reservation-admin/reservations",
            name: "ReservationsAdmin",
            meta: { displayedTitle: "Reservierungen", rights: ["reservations_fetch"] },
            component: () => import("@/views/reservationTool/views/admin/ManageReservations.vue"),
          },
          {
            name: "studioEmployee",
            path: "employee",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioDashboardEmployee.vue"),
            meta: {
              studioOnly: true,
              multiStudio: true,
              includeTeams: true,
              displayedTitle: "Mitarbeiter",
              needsLoader: true,
              rights: ["g_employeemanager"],
            },
          },
          {
            name: "studioDaycare",
            path: "daycare",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioDashboardDaycare.vue"),
            meta: { displayedTitle: "Kinderhort", needsLoader: true, rights: ["g_daycare"] },
          },
          {
            name: "openingHours",
            path: "opening-hours",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioDashboardOpeningHours.vue"),
            meta: { studioOnly: true, multiStudio: true, displayedTitle: "Öffnungszeiten", needsLoader: true, rights: ["g_employeemanager"] },
          },
          {
            name: "websiteContent",
            path: "website",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioDashboardWebsiteContent.vue"),
            meta: { displayedTitle: "Webseite", rights: ["g_websitecontent", "g_websitecontentstudioadmin"] },
          },
          {
            name: "websiteJobTypes",
            path: "website/jobs",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/components/WebsiteJobTypes.vue"),
            meta: { displayedTitle: "Job Typen", rights: ["g_websitecontent"] },
          },
          {
            name: "websiteJobTypes",
            path: "website/offers",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/components/WebsiteOffersManager.vue"),
            meta: { displayedTitle: "Angebote und Services", rights: ["g_websitecontent"] },
          },
          {
            name: "studioSlimMe",
            path: "slim-me",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/studio/studioDashboardSlimMe.vue"),
            meta: { displayedTitle: "Slim ME", needsLoader: true, rights: ["u_search"] },
          },
        ],
      },
      {
        name: "communication",
        path: "communication",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboard.vue"),
        children: [
          {
            name: "communicationNews",
            path: "news",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardNews.vue"),
            meta: { displayedTitle: "News", needsLoader: true, rights: ["mk_news"] },
          },
          {
            name: "communicationPopups",
            path: "popups",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardPopups.vue"),
            meta: { displayedTitle: "Popups", needsLoader: true, rights: ["mk_popup"] },
          },
          {
            name: "communicationPopupsNew",
            path: "popupsnew",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardPopupsNew.vue"),
            meta: { displayedTitle: "Popups", needsLoader: false, rights: ["mk_popup"] },
          },
          {
            name: "communicationQRCode",
            path: "qrcode",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardQRCode.vue"),
            meta: { displayedTitle: "QR-Code", rights: ["mk_qrcode"] },
          },
          {
            name: "communicationDashboardCampaign",
            path: "campaign",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardCampaign.vue"),
            meta: { displayedTitle: "Kampagne", needsLoader: true, rights: ["mk_campaigns"] },
          },
          {
            name: "communicationDashboardPush",
            path: "push",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardPush.vue"),
            meta: { displayedTitle: "Push", rights: ["mk_push"] },
          },
          {
            name: "communicationDashboardSlideManager",
            path: "slides",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/communication/communicationDashboardSlideManager.vue"),
            meta: { displayedTitle: "Slides", needsLoader: true, rights: ["mk_slider"], hideBottomNavigation: true },
          },
        ],
      },
      /*
			path: '/devices',
		name: 'DeviceList',
		component: DeviceList,
		children: [
			{
				path: 'create',
				name: 'DeviceCreate',
				component: DeviceForm,
				children: [
					{
						path: 'exercise/create',
						name: 'DeviceExerciseCreate',
						component: DeviceExerciseForm,
					},
				],
			},
			*/
      {
        name: "devices",
        path: "devices",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/devices/devicesDashboard.vue"),
        children: [
          {
            name: "devicesDashboardList",
            path: "list",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/devices/devicesDashboardList.vue"),
            meta: { displayedTitle: "Geräte Verwaltung", needsLoader: true, rights: ["ex_create", "ex_edit", "ex_delete", "ex_transfer"] },
          },
          {
            name: "devicesDashboardForm",
            path: "form",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/devices/devicesDashboardForm.vue"),
            meta: { rights: ["ex_create", "ex_edit", "ex_delete", "ex_transfer"] },
          },
          {
            name: "devicesDashboardExerciseForm",
            path: "exerciseform",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/devices/devicesDashboardExerciseForm.vue"),
            meta: { rights: ["ex_create", "ex_edit", "ex_delete", "ex_transfer"] },
          },
        ],
      },
      {
        name: "shop",
        path: "shop",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/shop/shopDashboard.vue"),
        children: [
          {
            name: "shopProducts",
            path: "products",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/shop/shopProducts.vue"),
            meta: { displayedTitle: "Produkte", rights: ["shop_manage"] },
          },
          {
            name: "shopPurchases",
            path: "purchases",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/shop/shopPurchases.vue"),
            meta: { displayedTitle: "Einkäufe", rights: ["shop_purchase_view", "shop_manage"] },
          },
        ],
      },
      {
        name: "nutrition",
        path: "nutrition",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/nutrition/nutritionDashboard.vue"),
        children: [
          {
            name: "nutritionSearch",
            path: "search",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/nutrition/nutritionSearch.vue"),
            meta: { displayedTitle: "Ernährung Suche", rights: ["stat_admin", "nutrition_admin"] },
          },
          {
            name: "nutritionCustomers",
            path: "customers",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/nutrition/nutritionCustomers.vue"),
            meta: { displayedTitle: "Kunden", rights: ["stat_admin", "nutrition_admin"] },
          },
        ],
      },
      {
        name: "anamnese",
        path: "anamnese",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/anamnese/anamneseDashboard.vue"),
        children: [
          {
            name: "anamneseDashboardSearch",
            path: "search",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/anamnese/anamneseDashboardSearch.vue"),
            meta: { displayedTitle: "Anamnesebögen" },
          },
          {
            name: "anamneseDashboardSettings",
            path: "settings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/anamnese/anamneseDashboardSettings.vue"),
            meta: { displayedTitle: "Anamnesebogen Einstellungen" },
          },
        ],
      },
      {
        name: "membercard",
        path: "membercard",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/membercard/membercardDashboard.vue"),
        children: [
          {
            name: "membercardDashboardAdmin",
            path: "admin",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/membercard/membercardDashboardAdmin.vue"),
            meta: {
              displayedTitle: "Membercards",
              needsLoader: true,
              rights: ["m_downloadList", "m_signupUser", "m_viewSubs", "m_createSubs", "m_createMembercard"],
            },
          },
        ],
      },
      {
        name: "timestop",
        path: "timestop",
        meta: {},
        component: () => import("@/views/dashboard/timestop/timestopView.vue"),
        childen: [],
      },
      {
        name: "timestopSettings",
        path: "timestop/settings",
        meta: {},
        component: () => import("@/views/dashboard/timestop/timestopSettings.vue"),
        childen: [],
      },
      {
        name: "leads",
        path: "leads",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboard.vue"),
        children: [
          {
            name: "leadsDashboardLeadsDeprecated",
            path: "referral-deprecated",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardLeadsDeprecated.vue"),
            meta: {
              displayedTitle: "Weiterempfehlungen (ALT)",
              needsLoader: true,
              rights: ["af_downloadList", "af_view", "af_edit", "af_settingsEdit"],
            },
          },
          {
            name: "leadsDashboardLeadsList",
            path: "leads-list",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardLeadsList.vue"),
            meta: { displayedTitle: "Anfragen Liste", needsLoader: true, rights: ["af_downloadList", "af_view", "af_edit", "af_settingsEdit"] },
          },
          {
            name: "leadsDashboardReferralList",
            path: "referral-list",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardReferralList.vue"),
            meta: {
              displayedTitle: "Weiterempfehlungen Liste",
              needsLoader: true,
              rights: ["af_downloadList", "af_view", "af_edit", "af_settingsEdit"],
            },
          },
          {
            path: "cost",
            name: "leadsCostManager",
            meta: { displayedTitle: "Lead Kosten", rights: ["af_cost"] },
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsCostManager.vue"),
          },
          {
            path: "all",
            name: "leadsDashboardAllLeads",
            meta: { displayedTitle: "Alle Anfragen", rights: ["af_downloadList", "af_view", "af_edit", "af_settingsEdit"] },
            component: () => import("@/views/dashboard/leads/leadsDashboardAllLeads.vue"),
          },
          {
            name: "leadsDashboardReferralSettings",
            path: "referral-settings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardReferralSettings.vue"),
            meta: { displayedTitle: "Anfragen Einstellungen", needsLoader: true, rights: ["af_settingsEdit"] },
          },
          {
            name: "leadsDashboardSettings",
            path: "leads-settings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardSettings.vue"),
            meta: { displayedTitle: "Weiterempfehlungen Einstellungen", needsLoader: true, rights: ["af_leadSettings"] },
          },
          {
            name: "leadsDashboardCategorySettings",
            path: "category-settings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardCategorySettings.vue"),
            meta: { displayedTitle: "Lead Einstellungen", rights: ["af_leadSettings"] },
            children: [
              {
                name: "leadsDashboardLeadSettings",
                path: ":id",
                component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/leads/leadsDashboardLeadSettings.vue"),
                meta: { displayedTitle: "Lead Einstellungen", rights: ["af_leadSettings"] },
              },
            ],
          },
        ],
      },
      {
        name: "groupFitness",
        path: "gf",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboard.vue"),
        children: [
          {
            name: "groupFitnessDashboardRatings",
            path: "ratings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardRatings.vue"),
            meta: { displayedTitle: "Group Fitness Bewertungen", needsLoader: true, rights: ["gf_r_viewAll", "gf_r_threestars"] },
          },
          {
            name: "groupFitnessDashboardCourses",
            path: "courses",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardCourses.vue"),
            meta: { displayedTitle: "Group Fitness Kurse", needsLoader: true, rights: ["gf_c_create", "gf_c_edit", "gf_c_delete", "gf_c_plan"] },
          },
          {
            name: "groupFitnessDashboardLabels",
            path: "labels",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardLabels.vue"),
            meta: { displayedTitle: "Group Fitness Labels", needsLoader: true, rights: ["l_edit"] },
          },
          {
            name: "groupFitnessDashboardRooms",
            path: "rooms",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardRooms.vue"),
            meta: { displayedTitle: "Group Fitness Räume", needsLoader: true, rights: ["r_edit"] },
          },
          {
            name: "groupFitnessDashboardVideos",
            path: "videos",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardVideos.vue"),
            meta: { displayedTitle: "Group Fitness Videos", needsLoader: true, rights: ["a_add", "a_delete", "a_edit"] },
          },
          {
            name: "groupFitnessDashboardSettings",
            path: "settings",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardSettings.vue"),
            meta: { displayedTitle: "Group Fitness Einstellungen", needsLoader: true, rights: ["gf_c_signupRange"] },
          },
          {
            name: "groupFitnessDashboardDownloads",
            path: "downloads",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardDownloads.vue"),
            meta: { displayedTitle: "Group Fitness Downloads", needsLoader: true, rights: ["gf_c_plan", "gf_cp_instructor"] },
          },
          {
            name: "groupFitnessDashboardEventHome",
            path: "event",
            rights: ["gf_c_create", "gf_c_edit", "gf_c_delete", "gf_c_plan"],
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardEventHome.vue"),
            children: [
              {
                name: "groupFitnessDashboardEventForm",
                path: "create",
                component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardEventForm.vue"),
                meta: { displayedTitle: "Group Fitness Event erstellen", rights: ["gf_c_create", "gf_c_edit", "gf_c_delete", "gf_c_plan"] },
              },
              {
                name: "groupFitnessDashboardEventForm",
                path: "edit/:id",
                component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/groupFitness/groupFitnessDashboardEventForm.vue"),
                meta: { displayedTitle: "Group Fitness Event bearbeiten", rights: ["gf_c_create", "gf_c_edit", "gf_c_delete", "gf_c_plan"] },
              },
            ],
          },
        ],
      },
      {
        name: "user",
        path: "user",
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/user/userDashboard.vue"),
        children: [
          {
            name: "userDashboardSearch",
            path: "search",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/user/userDashboardSearch.vue"),
            meta: { displayedTitle: "Kundensuche", rights: ["u_search"] },
          },
          {
            name: "userDashboardCustomerSelected",
            path: "search/:id",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/user/userDashboardCustomer.vue"),
            meta: { displayedTitle: "Kundensuche", rights: ["u_search"] },
          },
          {
            name: "userDashboardRightList",
            path: "rightlist",
            component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/user/userDashboardRightList.vue"),
            meta: { displayedTitle: "Rechte Liste", rights: ["u_rightList"] },
          },
        ],
      },
    ],
  },
]
